import * as React from 'react';
import Button from 'components/Button';
import { ScreeningToolQuestionType } from '../types/ScreeningToolQuestion';
import { ScreeningToolQuestionAnswerOptionType } from '../types/ScreeningToolQuestionAnswerOption';
import Progress from 'components/Progress';
import RadioButton from 'components/RadioButton';

type QuestionWithOptions = ScreeningToolQuestionType & { answer_options: ScreeningToolQuestionAnswerOptionType[] };

type QuestionsProps = {
  questions: QuestionWithOptions[];
  currentIdx: number;
  selectedOptionId: number | null;
  handleBack: () => void;
  handleNext: () => void;
  handleOptionSelection: (id: number) => void;
  handleSubmit: () => void;
  loading: boolean;
  show: boolean;
};

const Questions: React.FC<QuestionsProps> = ({
  questions,
  currentIdx,
  selectedOptionId,
  handleOptionSelection,
  handleBack,
  handleNext,
  handleSubmit,
  loading,
  show,
}) => {

  if (show) return null;
  const currentQuestion = questions[currentIdx];
  const total = questions.length;
  const completed = currentIdx + 1;
  const progressValue = (completed / total) * 100;

  return (
    <div className="md:p-4 rounded-lg md:shadow-md">
      <div className="mb-4">
        <Progress value={progressValue} />
        <div className="flex justify-between mt-1 text-xs text-gray-500">
          <span>
            Question {completed} of {total}
          </span>
        </div>
      </div>
      <div className="mb-6">
        {currentQuestion.instructions && (
          <div>
            <div className="text-sm text-gray-600 mt-6 mb-4">
              {currentQuestion.instructions}
            </div>
            <hr className="border-gray-300 mb-4" />
          </div>
        )}
        <div className="text-base font-medium mb-4">{currentQuestion.label}</div>
        <form>
          <div className="flex flex-col gap-3 mt-8">
            {currentQuestion.answer_options.map(option => (
              <RadioButton
                key={option.id}
                name={`question_${currentQuestion.id}`}
                value={option.id}
                checked={selectedOptionId === option.id}
                onChange={() => handleOptionSelection(option.id)}
                onContainerClick={() => handleOptionSelection(option.id)}
              >
                <span className="font-medium text-gray-800">{option.label}</span>
              </RadioButton>
            ))}
          </div>
        </form>
      </div>
      <div className="flex justify-between">
        <Button
          onClick={handleBack}
          variant="secondaryOutlined"
          className='border-none'
          disabled={ currentIdx == 0 || loading}
        >
          Back
        </Button>
        <Button
          loading={loading}
          disabled={selectedOptionId == null || loading}
          onClick={ currentIdx === questions.length - 1 ? handleSubmit : handleNext}
        >
          {currentIdx === questions.length - 1 ? 'Finish' : 'Next'}
        </Button>
      </div>
    </div>
  );
};

export default Questions;
